module.exports = __webpack_public_path__ + "static/media/al_algarve_-_estudo_e_caracterizacao_proprietarios_alojamentos_hospedes.b97c9069.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/docs/al_algarve_-_estudo_e_caracterizacao_proprietarios_alojamentos_hospedes.pdf
// module id = 411
// module chunks = 0